import { axiosPrivateUploadFile } from "../accounts/api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useAxiosPrivateUploadFile = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth();
  useEffect(() => {
    const requestIntercept = axiosPrivateUploadFile.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `JWT ${auth?.accessToken}`;
        }
        config.headers["Content-Type"] = "multipart/form-data";
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );

    const responseIntercept = axiosPrivateUploadFile.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers["Authorization"] = `JWT ${newAccessToken}`;
          return axiosPrivateUploadFile(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivateUploadFile.interceptors.request.eject(requestIntercept);
      axiosPrivateUploadFile.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosPrivateUploadFile;
};

export default useAxiosPrivateUploadFile;
